module.exports = __webpack_public_path__ + "static/media/AB_figures_mobile_reseller_2.bae92a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_figures_mobile_reseller_2.png
// module id = 1101
// module chunks = 0